import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import RotatingWords from './RotatingWords';
import styles from './Hero.module.css';

const showcaseProjects = [
  { name: 'Strandx', category: 'Platform', color: '#4A90E2' },
  { name: 'OpenAth', category: 'Web App', color: '#06b6d4' },
  { name: 'Petz4Days', category: 'Web App', color: '#E91E63' },
  { name: 'Help A Brotha', category: 'Web App', color: '#8B5CF6' },
];

const Hero: React.FC = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.heroBackground}>
        <div className={styles.gradientBlob1}></div>
        <div className={styles.gradientBlob2}></div>
      </div>
      
      <div className={styles.heroContainer}>
        <motion.div 
          className={styles.heroContent}
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <p className={styles.heroTag}>Web design & development</p>
          
          <h1 className={styles.heroTitle}>
            <span className={styles.titleLine}>We build</span>
            <span className={styles.titleRotatingLine}>
              <RotatingWords />
            </span>
            <span className={styles.titleLine}>people love to use</span>
          </h1>
          
          <p className={styles.heroDescription}>
            From business websites and web apps to games and more — 
            we design and ship digital products that look great and work reliably.
          </p>

          <div className={styles.heroActions}>
            <Link to="/contact" className={styles.primaryButton}>
              Start a Project
            </Link>
            <Link to="/projects" className={styles.secondaryButton}>
              View Our Work
            </Link>
          </div>
        </motion.div>

        <div className={styles.heroVisual}>
          <div className={styles.showcaseGrid}>
            {showcaseProjects.map((project) => (
              <div
                key={project.name}
                className={styles.showcaseCard}
              >
                <div className={styles.cardAccent} style={{ backgroundColor: project.color }} />
                <div className={styles.cardInner}>
                  <span className={styles.cardCategory}>{project.category}</span>
                  <h3 className={styles.cardName}>{project.name}</h3>
                  <div className={styles.cardPreview}>
                    <div className={styles.previewBar} />
                    <div className={styles.previewContent}>
                      <div className={styles.previewLine} style={{ width: '70%' }} />
                      <div className={styles.previewLine} style={{ width: '90%' }} />
                      <div className={styles.previewLine} style={{ width: '50%' }} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
